export default __webpack_public_path__ + "static/media/hht2_Intonation_09.efb31dd5.png";